<template>
  <v-row no-gutters>
    <v-col cols="12" class="px-3 mt-3" style="max-height: 21px">
      <v-row no-gutters justify="space-between" align="center">
        <span class="mainText textType--text">{{
          $t('message.pages.credits.creditsDrawerInfo.title')
        }}</span>
        <!-- <v-col>
          <LearnMoreBtn
            :customTooltipMessage="
              $t(
                'message.pages.credits.creditsDrawerInfo.tooltipMessages.aiCredits'
              )
            "
            :onClickBtn="() => handleGoToCreditsArticle()"
            customTooltipMessageStyle="max-width: 300px;"
            customClass="ask__btn--tiny"
          />
        </v-col> -->
        <div
          style="min-width: 50px"
          class="d-flex flex-row align-center justify-end"
        >
          <img
            style="padding-bottom: 2px"
            src="../../../assets/credit_small_icon.svg"
          />

          <span
            v-if="!creditsLoading"
            class="pl-1 limitInfoText textType--text"
          >
            <b
              >{{
                Math.floor(accountBalance).toLocaleString(currencyLocale, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
              }}
            </b>
          </span>
          <v-skeleton-loader
            v-else
            class="rounded"
            type="chip"
            height="20"
            width="40"
            tile
          ></v-skeleton-loader>
        </div>
      </v-row>
    </v-col>
    <!-- <v-col cols="12" class="px-4 mb-2">
      <v-row no-gutters justify="space-between" align="center">
        <span
          @click="handleOpenCreditModal"
          style="cursor: pointer"
          class="buttonsText primary--text"
          >+ {{ $t('message.pages.credits.creditsDrawerInfo.add') }}</span
        >
        <span
          @click="handleGoToCreditDetails"
          style="cursor: pointer"
          class="buttonsText primary--text"
        >
          {{ $t('message.pages.credits.creditsDrawerInfo.details') }}
        </span>
      </v-row>
    </v-col> -->
  </v-row>
</template>

<script>
import i18n from '@/translations/lang'
import creditsApi from '@/services/creditsApi'
// import LearnMoreBtn from '@/components/LearnMoreBtn.vue'

export default {
  name: 'CreditsDrawerInfo',
  // components: { LearnMoreBtn },
  data: () => ({
    creditsLoading: false,
    errors: {
      unknownError: false,
      shownErrMsg: '',
      errMsg: i18n.t('message.errors.unexpectedError'),
    },
    accountBalance: 0,
    currency: 'brl',
    currencyLocale: 'pt-BR',
    creditLinks: {
      pt: 'https://help.pandavideo.com/pt-br/article/como-funcionam-os-creditos-da-panda-video-sl8v0f/',
      en: 'https://help.pandavideo.com/en-us/article/how-does-panda-video-credits-work-1w67k8n/',
    },
  }),
  computed: {},
  mounted() {
    this.loadCredits()
    this.setCurrencyConfig()
    this.$root.$on('reloadBalanceDrawer', async () => {
      const maxAttempts = 3
      let attempts = 0

      const reloadCredits = async () => {
        const oldBalance = this.accountBalance
        await this.getCreditsInfo()
        await this.loadCredits()

        if (this.accountBalance === oldBalance && attempts < maxAttempts) {
          attempts++
          await reloadCredits()
        }
      }
      await reloadCredits()
    })
  },
  beforeDestroy() {
    this.$root.$off('reloadBalanceDrawer')
  },
  methods: {
    async loadCredits() {
      this.creditsLoading = true
      await this.getCreditsInfo()
      this.creditsLoading = false
    },
    async getCreditsInfo() {
      try {
        const { data } = await creditsApi.getCreditsBalance()
        this.accountBalance = data.balance
        this.$root.$emit('accountBalance', this.accountBalance)
      } catch (error) {
        console.error('error', error)
      }
    },
    setCurrencyConfig() {
      const currency = this.$store.state.user.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    handleOpenCreditModal() {
      this.$root.$emit('creditsBuyModal')
    },
    handleGoToCreditDetails() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
    },
    handleGoToCreditsArticle() {
      const articleLink =
        this.creditLinks[this.$i18next.resolvedLanguage] ??
        this.creditLinks['en']
      window.open(articleLink, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.mainText {
  font-size: 12px;
  font-weight: 400;
}
.buttonsText {
  font-size: 12px;
  font-weight: 500;
}
</style>
<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
.limitInfoText {
  color: #3f404c;
  font-size: 12px;
  font-weight: 500;
}
</style>
